import React from "react";
import { Section, SectionHeading } from "../Section";
import { CTAButton } from "../CTAButton";
import { problems } from "../../data/landing";
export function Problems() {
  return <Section className="bg-sky-soft" data-id="element-248" data-mp="1d067pi7ofjl8">
      <SectionHeading title="Does any of this sound familiar?" data-id="element-249" data-mp="1d17swfiepmgo" />

      <ol className="mt-10 grid gap-x-10 md:grid-cols-2" data-id="element-250" data-mp="1hzj5gy036b2l">
        {problems.map((p, i) => <li key={p.title} className="flex gap-4 border-t-2 border-navy/10 py-6" data-id="element-251" data-mp="kbhb9whkg2ft" data-mpi={i}>
            <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-full bg-navy font-display text-xl font-bold text-sun" data-id="element-252" data-mp="pabv91r9rx1i">
              {i + 1}
            </span>
            <div data-id="element-253" data-mp="u7c4tmnbvhxd">
              <h3 className="font-display text-xl font-bold leading-snug text-navy" data-id="element-254" data-mp="z058s8az2m8e">{p.title}</h3>
              <p className="mt-2 text-[16px] leading-relaxed text-ink/80" data-id="element-255" data-mp="1krdunarl7uc">{p.body}</p>
            </div>
          </li>)}
      </ol>

      <p className="mx-auto mt-8 max-w-2xl text-center text-lg font-bold leading-relaxed text-navy" data-id="element-256" data-mp="6isuz2omqx36">
        If you recognize these challenges, the Pediatric Articulation Clinical Blueprint™ was designed with your
        planning workflow in mind.
      </p>

      <div className="mt-8" data-id="element-257" data-mp="3smtmgq5h5pyn">
        <CTAButton label="Explore the complete system" data-id="element-258" data-mp="3sm1wbuunckfr" />
      </div>
    </Section>;
}